/**
 * Nonna's PDP gallery — thumbnail click swaps the hero image.
 *
 * Each .nonnas-pdp__thumb-btn has data-image-src + data-image-srcset
 * attributes pointing at progressively-sized versions of one product
 * media item. On click we swap those into the hero <img> and toggle
 * the .is-active state on the <li>.
 */
(function () {
  function init(root) {
    // Target the hero by class — Shopify's image_tag filter doesn't reliably
    // emit custom data attributes, so we anchor to the BEM classname instead.
    const hero = root.querySelector('.nonnas-pdp__img');
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');
    if (!hero || thumbs.length === 0) return;

    thumbs.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const src = btn.dataset.imageSrc;
        const srcset = btn.dataset.imageSrcset;
        const alt = btn.dataset.imageAlt || '';
        if (!src) return;

        // Smooth fade swap to avoid a hard flicker
        hero.style.opacity = '0';
        hero.style.transition = 'opacity 180ms ease';

        const swap = () => {
          if (srcset) hero.srcset = srcset;
          hero.src = src;
          hero.alt = alt;
          // wait until the new image has paint dimensions before fading back in
          if (hero.complete) {
            hero.style.opacity = '1';
          } else {
            hero.addEventListener('load', () => { hero.style.opacity = '1'; }, { once: true });
          }
        };

        // small timeout so the fade-out registers before the swap
        setTimeout(swap, 60);

        // active state
        const list = btn.closest('.nonnas-pdp__thumbs');
        if (list) {
          list.querySelectorAll('.nonnas-pdp__thumb').forEach((li) => li.classList.remove('is-active'));
          const li = btn.closest('.nonnas-pdp__thumb');
          if (li) li.classList.add('is-active');
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.nonnas-pdp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
